/* src/app/modules/dna-syngovia/components/dna-syngovia-healthcheck/dna-syngovia-healthcheck.component.scss */
:host {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.header-container {
  width: 100%;
  height: fit-content;
  display: flex;
  align-items: center;
  gap: 1rem;
  background: var(--base-2, #F5F5F5);
  padding: 0.5rem 0.5rem 0 0.5rem;
  box-sizing: border-box;
}
.header-container--tablet,
.header-container--phone {
  flex-wrap: wrap;
}
.header-item--desktop-large,
.header-item--desktop {
  width: 50%;
}
.header-item--tablet,
.header-item--phone {
  width: 100%;
}
.server-card {
  border: unset;
  cursor: pointer;
  min-width: 11.8125rem;
  width: 100%;
  height: 4rem;
  padding: 0.5rem 1rem;
  background-color: rgba(var(--ui-1), var(--opacity-7));
  display: flex;
  gap: 1rem;
  align-items: center;
}
.server-card sh-icon {
  opacity: var(--opacity-4);
}
.server-card:focus sh-icon,
.server-card:focus sh-text:first-of-type,
.server-card:hover sh-icon,
.server-card:hover sh-text:first-of-type {
  opacity: var(--opacity-1);
  color: var(--text-primary);
}
.server-card--selected {
  background: var(--white, #FFF);
}
.server-card--selected sh-icon,
.server-card--selected sh-text:first-of-type {
  opacity: var(--opacity-1);
  color: var(--text-primary);
}
.server-card-description {
  display: flex;
  flex-direction: column;
  text-align: start;
}
.server-card-description sh-text {
  line-height: 1rem;
}
.server-card-description sh-text:first-of-type {
  font-weight: 700;
}
.summary-container {
  box-shadow: 0 -0.0625rem 0.125rem 0 rgba(0, 0, 0, 0.05), 0 0.125rem 0.25rem 0 rgba(0, 0, 0, 0.1);
  height: fit-content;
  background: var(--white, #FFF);
  margin-top: -0.375rem;
}
.table-container {
  width: 100%;
  min-height: 19.25rem;
}
.empty-state-container {
  box-shadow: 0 -0.0625rem 0.125rem 0 rgba(0, 0, 0, 0.05), 0 0.125rem 0.25rem 0 rgba(0, 0, 0, 0.1);
  width: 100%;
  height: 21.5625rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
/*# sourceMappingURL=dna-syngovia-healthcheck.component.css.map */
